var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinner = function SvgSpinner(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.753 8c.689 0 1.257-.562 1.15-1.242A8 8 0 0 0 9.243.097C8.561-.01 8 .558 8 1.247c0 .69.565 1.233 1.237 1.388a5.5 5.5 0 0 1 4.128 4.128C13.52 7.435 14.064 8 14.753 8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export default ForwardRef;